export default {
	install(Vue) {
		Vue.prototype.$alert = function (type, message, timeout = true, icon = undefined) {
			this.$store.commit("alerts/add", { type, message, timeout, icon });
		};

		Vue.prototype.$error = function (message, timeout = true) {
			this.$store.commit("alerts/add", { type: "error", message, timeout });
		};

		Vue.prototype.$success = function (message, timeout = true) {
			this.$store.commit("alerts/add", { type: "success", message, timeout });
		};

		Vue.prototype.$warning = function (message, timeout = true) {
			this.$store.commit("alerts/add", { type: "warning", message, timeout, textColor: "black" });
		};

		Vue.prototype.$callDisabled = function (message, icon = "mdi-phone-off") {
			this.$store.commit("alerts/add", {
				id: "call-disabled",
				type: "warning",
				message,
				timeout: false,
				icon,
				textColor: "black",
				largeIcon: true
			});
		};

		Vue.prototype.$clearCallDisabled = function () {
			this.$store.commit("alerts/removeById", "call-disabled");
		};

		Vue.prototype.$awayForwardingEnabled = function (message, icon = "mdi-phone-off") {
			this.$store.commit("alerts/add", {
				id: "away-forwarding-enabled",
				type: "warning",
				message,
				timeout: false,
				icon,
				textColor: "black",
				largeIcon: true
			});
		};

		Vue.prototype.$clearAwayForwardingEnabled = function () {
			this.$store.commit("alerts/removeById", "away-forwarding-enabled");
		};
	}
};
